import { frontApp, backgroundApp, resize } from "./appPixi.js";
import { getScale, getWidthScale, spriteSettings } from "./utility.js";
import { promiseAssets } from "./assetsLoad.js";
import {
  setValuesToInitial,
  isGameStarted,
} from "./gameLogic.js";
import * as PIXI from "pixi.js";
import { startGameProgressBar } from "./CommonProgressBar.js";
import {
  settings,
  path,
  getCrashBackgroundAsset,
  getThemeTwoLayout,
} from "./settings.js";
import { getActiveThemeSlug, getThemeSlug } from "../../theme/themes";
import { random } from "lodash";

let uiCreated = false;

let appWidth = frontApp.screen.width;
let appHeight = frontApp.screen.height;

let appAspectRatio = frontApp.screen.width / frontApp.screen.height;

export let appAspectRatioX = appWidth / 1920;
export let appAspectRatioY = appHeight / 1080;

// Which element covers how much area of the screen (as per figma)
const scalingPercentage = {
  desktop: {
    mainPlane: 19.3,
  },
  mobile: {
    mainPlane: 49.72,
  },
};

const smokeAceMultiplier = {
  backgroundColor: 0x59210d,
  borderColor: 0xb34219,
  width: 180,
  height: 100,
  fontSize: 52,
  lineHeight: 60,
  flyingTextColor: "#85E0AF",
  crashedTextColor: "#F08A75",
  borderRadius: 12,
  borderWidth: 1,
  landscapeTop: 20,
  portraitScale: 0.5,
  right: 20,
};

const smokeAceStarting = {
  backgroundColor: 0x59210d,
  barBackgroundColor: 0xffffff,
  barBackgroundAlpha: 0.1,
  barColor: 0x33cc7a,
  barHeight: 12,
  barWidth: 156,
  borderColor: 0x863213,
  borderRadius: 12,
  borderWidth: 1,
  fontSize: 20,
  height: 60,
  lineHeight: 28,
  portraitScale: 0.5,
  right: 20,
  textColor: "#FCEEE9",
  top: 20,
  width: 180,
};

let smokeAceLoadingTextures = null;

function getSmokeAceLoadingTextures() {
  if (smokeAceLoadingTextures || !frontApp?.renderer)
    return smokeAceLoadingTextures;

  const track = new PIXI.Graphics();
  track.lineStyle(1, smokeAceStarting.barColor, 1, 1);
  track.beginFill(
    smokeAceStarting.barBackgroundColor,
    smokeAceStarting.barBackgroundAlpha,
  );
  track.drawRoundedRect(
    0,
    0,
    smokeAceStarting.barWidth,
    smokeAceStarting.barHeight,
    smokeAceStarting.barHeight / 2,
  );
  track.endFill();

  const fill = new PIXI.Graphics();
  fill.beginFill(smokeAceStarting.barColor);
  fill.drawRoundedRect(
    0,
    0,
    smokeAceStarting.barWidth,
    smokeAceStarting.barHeight,
    smokeAceStarting.barHeight / 2,
  );
  fill.endFill();

  smokeAceLoadingTextures = {
    fill: frontApp.renderer.generateTexture(fill),
    track: frontApp.renderer.generateTexture(track),
  };

  fill.destroy();
  track.destroy();

  return smokeAceLoadingTextures;
}

let xGraphic;
let yGraphic;

const containers = {
  rootContainer: new PIXI.Container(),
  dummyPlanesContainer: new PIXI.Container(),
  bgContainer: new PIXI.Container(),
  cloudContainer: new PIXI.Container(),
  loadingContainer: new PIXI.Container(),
  graphContainer: new PIXI.Container(),
  rocketContainer: new PIXI.Container(),
  axisContainer: new PIXI.Container(),
  centerTextContainer: new PIXI.Container(),
  graphViewportContainer: new PIXI.Container(),

  //BgApp
  BgRootContainer: new PIXI.Container(),
  BgContainer: new PIXI.Container(),
  cloudContainer: new PIXI.Container(),
};

const gameAssets = {
  //GameBg
  cloud1: new PIXI.Sprite(),
  cloud2: new PIXI.Sprite(),

  //Center Text
  centerBigText: new PIXI.Text(),
  centerSmallText: new PIXI.Text(),
  crashCenterText: new PIXI.Text(),
  cashedoutText1: new PIXI.Text(),
  cashedoutText2: new PIXI.Text(),
  cashedoutText3: new PIXI.Text(),
  multiplierBgBox: null,
  multiplierCrashed: false,
  loadingBgBox: null,

  //rocket
  // rocketTextures: [],
  rocket: new PIXI.Sprite(),

  nearestPlane: null,
  farthestPlane: null,

  // rocket explosion
  explosionAnim: null,

  //loadingScreen
  countdownText: "",
  loadingText: "",
  loadingBar1: new PIXI.Sprite(),
  loadingBar2: new PIXI.Sprite(),
  loadingBarMask: null,
  loadingMaxWidth: 0,

  //Axis
  axisDots: {
    x: [],
    y: [],
  },

  //Graph
  topLineGraph: new PIXI.Graphics(),
  bottomLineGraph: new PIXI.Graphics(),
  bottomGradient: new PIXI.Sprite(),

  //Fonts
  fonts: {
    bold: {},
    primaryExtraBold: {},
    semiBold: {},
    ultraRegular: {},
  },

  background: new PIXI.Sprite(),

  clouds: [],
};

function createUI() {
  if (!uiCreated) {
    appAspectRatio = resize();
    appWidth = frontApp.screen.width;
    appHeight = frontApp.screen.height;
    setupContainers();
    setupGameAssets();
    uiCreated = true;
  }

  setValuesToInitial();
}

function setupContainers() {
  frontApp.stage.addChild(containers.rootContainer);

  containers.rootContainer.addChild(
    containers.bgContainer,
    containers.axisContainer,
    containers.graphViewportContainer,
    containers.centerTextContainer,
    containers.loadingContainer,
  );

  containers.graphViewportContainer.addChild(
    containers.graphContainer,
    containers.rocketContainer,
    containers.dummyPlanesContainer,
  );

  //BgApp
  backgroundApp.stage.addChild(containers.BgRootContainer);
  containers.BgRootContainer.addChild(containers.BgContainer);
  containers.BgRootContainer.addChild(containers.cloudContainer);
  containers.BgRootContainer.position.set(
    backgroundApp.screen.width / 2,
    backgroundApp.screen.height / 2,
  );
}

function setupGameAssets() {
  createBackgroundd();
  createClouds();

  setUpFonts();
  // createBackground();
  createLoadingScreen();
  createRocket();
  createCenterText();
  createGraph();
  createDummyRockets();
  createCashoutPopup();
  // createAxis();
  updateCrashBackground();
  updateCrashRocket();
  updateCrashLoadingTheme();
}

function createBackgroundd() {
  gameAssets.background = spriteSettings(
    gameAssets.background,
    PIXI.Assets.get("Bg"),
    containers.BgContainer,
  );

  const isThemeTwo = getActiveThemeSlug() === "theme-two";
  const canvasWidth = backgroundApp.screen.width;
  const canvasHeight = backgroundApp.screen.height;
  const textureRatio =
    gameAssets.background.texture.width / gameAssets.background.texture.height;
  const isPortrait = window.innerWidth < window.innerHeight;

  if (isThemeTwo) {
    const yShift = isPortrait ? 0 : -80 * (canvasHeight / 1080);
    const minWidth = canvasWidth;
    const minHeight = canvasHeight + 2 * Math.abs(yShift);

    // Cover-fit: scale to fill both minWidth and minHeight
    let w = minWidth;
    let h = minWidth / textureRatio;
    if (h < minHeight) {
      h = minHeight;
      w = h * textureRatio;
    }

    gameAssets.background.width = w * 1.02;
    gameAssets.background.height = h * 1.02;
    // Anchor is 0.5 and BgRootContainer is at screen centre, so position (0, yShift) = centred on screen
    gameAssets.background.position.set(0, yShift);

    // Snap BgContainer immediately so background doesn't slide in from old position
    containers.BgContainer.position.set(0, 0);
  } else {
    // SmokeAce background is a fixed Figma composition, cover-fitted to the canvas.
    let w = canvasWidth;
    let h = canvasWidth / textureRatio;
    if (h < canvasHeight) {
      h = canvasHeight;
      w = h * textureRatio;
    }
    gameAssets.background.width = w;
    gameAssets.background.height = h;
    gameAssets.background.position.set(0, 0);
    containers.BgContainer.position.set(0, 0);
  }

  if (
    backgroundApp &&
    backgroundApp.renderer &&
    backgroundApp.renderer.background
  ) {
    backgroundApp.renderer.background.color = isThemeTwo ? 0x18173f : 0x342db1;
  }
}

export function updateCrashBackground(themeSlugOverride) {
  if (!gameAssets || !gameAssets.background) {
    return Promise.resolve();
  }

  const activeSlug = getThemeSlug(themeSlugOverride || getActiveThemeSlug());
  const isThemeTwo = activeSlug === "theme-two";
  const bgAsset = getCrashBackgroundAsset(activeSlug).src;

    if (frontApp && frontApp.screen) {
      appWidth = frontApp.screen.width;
      appHeight = frontApp.screen.height;
      appAspectRatioX = appWidth / 1920;
      appAspectRatioY = appHeight / 1080;
    }

    // Always re-centre BgRootContainer to match current canvas size after resize
    if (containers && containers.BgRootContainer) {
      containers.BgRootContainer.position.set(
        backgroundApp.screen.width / 2,
        backgroundApp.screen.height / 2,
      );
    }

    return PIXI.Assets.load(bgAsset)
      .then((texture) => {
        gameAssets.background.texture = texture;
        if (isThemeTwo) {
          const canvasWidth = backgroundApp.screen.width;
          const canvasHeight = backgroundApp.screen.height;
          const textureRatio = texture.width / texture.height;
          const isPortrait = window.innerWidth < window.innerHeight;

          const yShift = isPortrait ? 0 : -80 * (canvasHeight / 1080);
          const minWidth = canvasWidth;
          const minHeight = canvasHeight + 2 * Math.abs(yShift);

          // Cover-fit: scale to fill both minWidth and minHeight
          let w = minWidth;
          let h = minWidth / textureRatio;
          if (h < minHeight) {
            h = minHeight;
            w = h * textureRatio;
          }

          gameAssets.background.width = w * 1.02;
          gameAssets.background.height = h * 1.02;
          // Anchor is 0.5 and BgRootContainer is at screen centre, so position (0, yShift) = centred on screen
          gameAssets.background.position.set(0, yShift);
        } else {
          const canvasWidth = backgroundApp.screen.width;
          const canvasHeight = backgroundApp.screen.height;
          const textureRatio = texture.width / texture.height;
          let w = canvasWidth;
          let h = canvasWidth / textureRatio;
          if (h < canvasHeight) {
            h = canvasHeight;
            w = h * textureRatio;
          }
          gameAssets.background.width = w;
          gameAssets.background.height = h;
          gameAssets.background.position.set(0, 0);
          containers.BgContainer.position.set(0, 0);
        }

        if (
          backgroundApp &&
          backgroundApp.renderer &&
          backgroundApp.renderer.background
        ) {
          backgroundApp.renderer.background.color = isThemeTwo
            ? 0x18173f
            : 0x342db1;
        }

        if (
          backgroundApp &&
          backgroundApp.renderer &&
          backgroundApp.renderer.background
        ) {
          backgroundApp.renderer.background.alpha = isThemeTwo ? 0 : 1;
        }

        if (containers && containers.cloudContainer) {
          containers.cloudContainer.visible = !isThemeTwo;
        }

        if (containers && containers.graphContainer) {
          const isPortrait = window.innerWidth < window.innerHeight;
          const graphYPos = isThemeTwo
            ? isPortrait
              ? -appHeight * 0.02
              : appHeight * 0.02
            : 0;
          const graphXPos = isThemeTwo ? appWidth * 0.01 : 0;
          containers.graphContainer.position.set(graphXPos, graphYPos);
        }

        if (containers && containers.graphViewportContainer) {
          if (isThemeTwo) {
            const layout = getThemeTwoLayout(appWidth, appHeight);
            const scaleX = layout.isPortrait ? 0.85 : 0.7;
            const scaleY = layout.isPortrait ? 0.85 : 0.7;
            const isMobileSmall = window.innerWidth <= 540;
            const offsetX = isMobileSmall ? 15 : 50;
            const offsetY = appHeight * (1 - scaleY) - 30;
            containers.graphViewportContainer.scale.set(scaleX, scaleY);
            containers.graphViewportContainer.position.set(offsetX, offsetY);
          } else {
            containers.graphViewportContainer.scale.set(1, 1);
            containers.graphViewportContainer.position.set(0, 0);
          }
        }

        updateCrashLoadingTheme();
      })
      .catch((err) => console.error("Error updating crash background:", err));
}

export function updateCrashRocket() {
  if (gameAssets && gameAssets.rocket) {
    const isThemeTwo = getActiveThemeSlug() === "theme-two";
    const texture = isThemeTwo
      ? PIXI.Assets.get("rocketThemeTwo")
      : PIXI.Assets.get("smokeAceFly");
    if (texture) {
      gameAssets.rocket.texture = texture;
    }
    if (containers && containers.dummyPlanesContainer) {
      containers.dummyPlanesContainer.visible = isThemeTwo
        ? false
        : containers.rocketContainer.visible;
    }

    const layout = getThemeTwoLayout(appWidth, appHeight);
    const scaleFactor = isThemeTwo
      ? layout.isPortrait
        ? 2.6
        : 4.8
      : layout.isPortrait
        ? 0.9
        : 1.3;

    const rocketScale = layout.isPortrait
      ? isThemeTwo
        ? Math.min(0.7, 2.6 * appAspectRatioX)
        : Math.min(layout.rocketScaleMax, 1.8 * appAspectRatioX)
      : scaleFactor * appAspectRatioX;

    if (window.matchMedia("(orientation: portrait)").matches) {
      // Mobile
      let scaleMultiplier;
      if (isThemeTwo) {
        scaleMultiplier =
          window.innerWidth <= 360
            ? 0.75
            : window.innerWidth <= 540
              ? 0.9
              : window.innerWidth <= 768
                ? 1.15
                : 0.95;
      } else {
        // Scale down blimp progressively on smaller mobile viewports for Theme-One (classic)
        scaleMultiplier =
          window.innerWidth <= 360
            ? 0.65
            : window.innerWidth <= 540
              ? 0.8
              : window.innerWidth <= 768
                ? 0.63
                : window.innerWidth <= 1024
                  ? 0.65
                  : 1.1;
      }
      gameAssets.rocket.scale.set(rocketScale * scaleMultiplier);
    } else {
      // Desktop
      const scaleMult = window.innerWidth <= 768 ? 0.52 : 0.4;
      gameAssets.rocket.scale.set(rocketScale * scaleMult);
    }
    if (!isThemeTwo) {
      ensureClassicRocketLayerOrder();
    }
  }
}

function sortAnimation(unsortedArray) {
  unsortedArray.sort((a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });

  unsortedArray.sort((a, b) => {
    if (a.length < b.length) {
      return -1;
    }
    if (a.length > b.length) {
      return 1;
    }
    return 0;
  });

  return unsortedArray;
}

function createClouds() {
  let variab = sortAnimation(Object.keys(promiseAssets.clouds.data.frames));
  for (let i of variab) {
    const cloud = {
      sprite: new PIXI.Sprite(promiseAssets.clouds.textures[i]),
      speed: 1 + Math.random() * 5,
    };

    containers.cloudContainer.addChild(cloud.sprite);

    // console.log(backgroundApp.view.width+"||"+backgroundApp.view.height)

    if (window.innerWidth < window.innerHeight) {
      // console.log("mobile")
      cloud.sprite.scale.set(cloud.sprite.scale.x * 5, cloud.sprite.scale.y);
    }

    cloud.sprite.position.y = -100 + Math.random() * 400;
    gameAssets.clouds.push(cloud);
  }

  // console.log(gameAssets.clouds)

  // for (let index = 0; index < 4; index++) {
  //   const cloud = {
  //     sprite: new PIXI.Sprite(),
  //     speed: null
  // }
  // cloud.sprite = spriteSettings(cloud.sprite, promiseAssets.cloud[`cloud${index}`], containers.cloudsContainer)
  // cloud.sprite.anchor.set(0.5)
  // //cloud.sprite.position.set(-app.view.width / 2 + (Math.random() * (app.view.width)), -app.view.height - (Math.random() * -app.view.height * 0.3))
  // //cloud.sprite.scale.set((Math.random() * (0.6 - 0.2) + 0.2) * appAspectRatioX)
  // cloud.speed = (0.2 + Math.random()) * appAspectRatioX
  // gameAssets.clouds.push(cloud)
  // }
}

function setUpFonts() {
  gameAssets.fonts.bold.fontFamily = promiseAssets.bold.family;
  gameAssets.fonts.primaryExtraBold.fontFamily =
    promiseAssets.primaryExtraBold?.family || promiseAssets.bold.family;
  gameAssets.fonts.semiBold.fontFamily = promiseAssets.semiBold.family;
  gameAssets.fonts.ultraRegular.fontFamily = promiseAssets.ultraRegular.family;
}

function createBackground() {
  gameAssets.cloud1 = spriteSettings(
    gameAssets.cloud1,
    PIXI.Assets.get("allAssets").textures.cloud,
    containers.bgContainer,
  );
  gameAssets.cloud1.position.set(appWidth * 0.85, appHeight * 0.85);

  gameAssets.cloud2 = spriteSettings(
    gameAssets.cloud2,
    PIXI.Assets.get("allAssets").textures.cloud,
    containers.bgContainer,
  );
  gameAssets.cloud2.position.set(appWidth * 0.1, appHeight * 0.85);
}

let gameContainer;

//getAspectratio()

function getAspectratio() {
  gameContainer = document.getElementById("pixi-game-section");
  if (!gameContainer) {
    return appWidth / 1920;
  }
  return gameContainer.offsetWidth / 1920;
}

function createLoadingScreen() {
  gameAssets.loadingText = new PIXI.Text(
    "WAITING FOR NEXT ROUND",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.ultraRegular.fontFamily,
      fill: ["#8E092E"],
      fontSize: 100,
      align: "center",
    }),
  );
  gameAssets.loadingText.anchor.set(0.5);
  containers.loadingContainer.addChild(gameAssets.loadingText);

  gameAssets.countdownText = new PIXI.Text(
    "5",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.ultraRegular.fontFamily,
      fill: ["#8E092E"],
      fontSize: 80,
    }),
  );
  gameAssets.countdownText.anchor.set(0.5);
  gameAssets.countdownText.scale.set(1.5 * appAspectRatioX);
  //gameAssets.countdownText.position.set(appWidth * 0.5, appHeight * 0.32)
  containers.loadingContainer.addChild(gameAssets.countdownText);

  gameAssets.loadingBar1 = spriteSettings(
    gameAssets.loadingBar1,
    PIXI.Assets.get("loaderBg"),
    containers.loadingContainer,
  );

  gameAssets.loadingBar2 = spriteSettings(
    gameAssets.loadingBar2,
    PIXI.Assets.get("loaderFiller"),
    containers.loadingContainer,
  );

  gameAssets.loadingBar2.width = 0;

  containers.loadingContainer.visible = true;

  if (!window.matchMedia("(orientation: portrait)").matches) {
    const widthVal = gameContainer ? gameContainer.offsetWidth : appWidth;
    gameAssets.loadingText.scale.set(getAspectratio() * 0.65);
    // gameAssets.loadingText.position.set(gameContainer.offsetWidth * 0.5, gameAssets.loadingText.height*0.5)
    gameAssets.loadingText.position.set(
      widthVal * 0.4,
      gameAssets.loadingText.height * 0.5,
    );

    gameAssets.loadingBar1.scale.set(1.5 * getAspectratio());
    // gameAssets.loadingBar1.position.set(gameContainer.offsetWidth * 0.5, gameAssets.countdownText.position.y + gameAssets.loadingBar1.height*2)
    gameAssets.loadingBar1.position.set(
      appWidth * 0.28 + gameAssets.loadingBar1.width * 0.5,
      gameAssets.loadingText.position.y + gameAssets.loadingBar1.height * 2,
    );

    gameAssets.loadingBar2.scale.set(
      1 * getAspectratio(),
      1.5 * getAspectratio(),
    );
    gameAssets.loadingBar2.anchor.set(0);
    gameAssets.loadingBar2.position.set(
      gameAssets.loadingBar1.position.x - gameAssets.loadingBar1.width * 0.48,
      gameAssets.loadingBar1.position.y - gameAssets.loadingBar1.height * 0.3,
    );

    // gameAssets.countdownText.position.set(gameContainer.offsetWidth * 0.5, gameAssets.loadingText.position.y+gameAssets.countdownText.height*0.75)
    gameAssets.countdownText.scale.set(1 * getAspectratio());
    gameAssets.countdownText.position.set(
      gameAssets.loadingBar1.x -
        gameAssets.loadingBar1.width * 0.5 -
        gameAssets.countdownText.width * 0.8,
      gameAssets.loadingText.position.y +
        gameAssets.countdownText.height * 0.88,
    );
  } else {
    gameAssets.loadingText.scale.set(appAspectRatioX * 0.5);
    gameAssets.loadingText.position.set(appWidth * 0.5, appHeight * 0.1);
    gameAssets.loadingText.text = "WAITING \n FOR NEXT ROUND";

    gameAssets.countdownText.position.set(
      appWidth * 0.5 - gameAssets.countdownText.width * 3,
      gameAssets.loadingText.position.y + gameAssets.countdownText.height * 0.7,
    );
    gameAssets.countdownText.scale.set(appAspectRatioX);

    gameAssets.loadingBar1.scale.set(1.5 * appAspectRatioX);
    gameAssets.loadingBar1.position.set(
      appWidth * 0.5 + gameAssets.loadingBar1.width * 0.1,
      gameAssets.loadingText.position.y + gameAssets.loadingBar1.height * 2.5,
    );

    gameAssets.loadingBar2.scale.set(
      0.9 * appAspectRatioX,
      1.7 * appAspectRatioX,
    );
    gameAssets.loadingBar2.anchor.set(0);
    gameAssets.loadingBar2.position.set(
      gameAssets.loadingBar1.position.x - gameAssets.loadingBar1.width * 0.48,
      gameAssets.loadingBar1.position.y - gameAssets.loadingBar1.height * 0.325,
    );
  }

  // if (!window.matchMedia("(orientation: portrait)").matches) {
  //   gameAssets.loadingText.scale.set(appAspectRatioX * 0.7)
  //   gameAssets.loadingText.position.set(appWidth * 0.27, appHeight * 0.1)

  //   gameAssets.loadingBar1.scale.set(2 * appAspectRatioX)
  //   gameAssets.loadingBar1.position.set(appWidth * 0.7, appHeight * 0.1)

  //   gameAssets.loadingBar2.scale.set(1 * appAspectRatioX, 2 * appAspectRatioX)
  //   gameAssets.loadingBar2.anchor.set(1)
  //   gameAssets.loadingBar2.position.set(gameAssets.loadingBar1.position.x + gameAssets.loadingBar1.width * 0.48,
  //     gameAssets.loadingBar1.position.y + gameAssets.loadingBar1.height * 0.3)

  // } else {
  //   gameAssets.loadingText.scale.set(appAspectRatioX * 0.7)
  //   gameAssets.loadingText.position.set(appWidth * 0.5, appHeight * 0.1)
  //   gameAssets.loadingText.text = 'Waiting \n For Next Round'

  //   gameAssets.loadingBar1.scale.set(2 * appAspectRatioX)
  //   gameAssets.loadingBar1.position.set(appWidth * 0.5, appHeight * 0.2)

  //   gameAssets.loadingBar2.scale.set(1 * appAspectRatioX, 2 * appAspectRatioX)
  //   gameAssets.loadingBar2.anchor.set(1)
  //   gameAssets.loadingBar2.position.set(gameAssets.loadingBar1.position.x + gameAssets.loadingBar1.width * 0.48,
  //     gameAssets.loadingBar1.position.y + gameAssets.loadingBar1.height * 0.3)

  // }
}

function createCashoutPopup() {
  gameAssets.cashedoutText1 = new PIXI.Text(
    "YOU HAVE CASHED OUT",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.ultraRegular.fontFamily,
      fill: ["#004B47"],
      fontSize: 80,
    }),
  );

  containers.centerTextContainer.addChild(gameAssets.cashedoutText1);
  gameAssets.cashedoutText1.anchor.set(0.5);
  gameAssets.cashedoutText1.scale.set(0.7 * appAspectRatioX);

  gameAssets.cashedoutText2 = new PIXI.Text(
    "$17.6",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.ultraRegular.fontFamily,
      fill: ["#004B47"],
      fontSize: 80,
    }),
  );

  containers.centerTextContainer.addChild(gameAssets.cashedoutText2);
  gameAssets.cashedoutText2.anchor.set(0.5);
  gameAssets.cashedoutText2.scale.set(1 * appAspectRatioX);

  gameAssets.cashedoutText3 = new PIXI.Text(
    "MULTIPLIER X1.35",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.ultraRegular.fontFamily,
      fill: ["#004B47"],
      fontSize: 80,
    }),
  );

  containers.centerTextContainer.addChild(gameAssets.cashedoutText3);
  gameAssets.cashedoutText3.anchor.set(0.5);
  gameAssets.cashedoutText3.scale.set(0.4 * appAspectRatioX);

  if (window.matchMedia("(orientation: portrait)").matches) {
    // Mobile
    gameAssets.cashedoutText1.position.set(appWidth * 0.5, appHeight * 0.3);
    gameAssets.cashedoutText2.position.set(
      appWidth * 0.5,
      gameAssets.cashedoutText1.position.y +
        gameAssets.cashedoutText1.height * 0.5 +
        gameAssets.cashedoutText2.height * 0.5,
    );
    gameAssets.cashedoutText3.position.set(
      appWidth * 0.5,
      gameAssets.cashedoutText2.position.y +
        gameAssets.cashedoutText2.height * 0.5 +
        gameAssets.cashedoutText3.height * 0.5,
    );
  } else {
    // Desktop
    gameAssets.cashedoutText1.position.set(appWidth * 0.5, appHeight * 0.15);
    gameAssets.cashedoutText2.position.set(appWidth * 0.5, appHeight * 0.25);
    gameAssets.cashedoutText3.position.set(appWidth * 0.5, appHeight * 0.35);
  }
}

let isAnimationEnabled = true;

function toggleAnimation(toggle) {
  isAnimationEnabled = Boolean(toggle);
  containers.rocketContainer.visible = isAnimationEnabled;
  containers.graphContainer.visible = isAnimationEnabled;

  const isThemeTwo = getActiveThemeSlug() === "theme-two";
  containers.dummyPlanesContainer.visible = isThemeTwo ? false : isAnimationEnabled;
}

function applyAnimationVisibility() {
  toggleAnimation(isAnimationEnabled);
}

function createAxis() {
  const dotRadius = 1.5;
  const dotsNumberX = 20;
  const dotsNumberY = 11;
  const xDotColor = 0xffffff;
  const yDotColor = 0xffffff;

  let dotsDistanceX = appWidth / dotsNumberX;
  let dotsDistanceY = appHeight / dotsNumberY;

  // x-axis
  for (let i = 0; i < dotsNumberX; i++) {
    xGraphic = new PIXI.Graphics();
    containers.axisContainer.addChild(xGraphic);
    xGraphic.position.set(
      dotsDistanceX * i + appWidth * 0.015,
      appHeight * 0.98,
    );
    xGraphic.beginFill(xDotColor);
    xGraphic.drawCircle(0, 0, dotRadius);
    gameAssets.axisDots.x.push(xGraphic);
    xGraphic.endFill();
  }
  // y-axis
  for (let i = 0; i < dotsNumberY; i++) {
    yGraphic = new PIXI.Graphics();
    containers.axisContainer.addChild(yGraphic);
    yGraphic.position.set(appWidth * 0.015, dotsDistanceY * i);
    yGraphic.beginFill(yDotColor);
    yGraphic.drawCircle(0, 0, dotRadius);
    gameAssets.axisDots.y.push(yGraphic);
    yGraphic.endFill();
  }

  function distance(p1, p2) {
    return Math.hypot(p2.x - p1.x, p2.y - p1.y);
  }

  const line = new PIXI.Graphics();
  containers.axisContainer.addChild(line);
  // line.position.set(150)
  const p1 = {
    x: appWidth * 0.03,
    y: appHeight * 0.96,
  };
  const p2 = {
    x: appWidth,
    y: appHeight * 0.96,
  };
  line.lineStyle(0.01, 0x000000);
  line.moveTo(p1.x, p1.y).lineTo(p2.x, p2.y);
  const dash = 5;
  const gap = 5;
  const len = distance(p1, p2);
  const norm = {
    x: (p2.x - p1.x) / len,
    y: (p2.y - p1.y) / len,
  };
  line.lineStyle(0.2, 0xffffff);
  line.moveTo(p1.x, p1.y).lineTo(p1.x + dash * norm.x, p1.y + dash * norm.y);
  var progress = dash + gap;
  while (progress < len) {
    line.moveTo(p1.x + progress * norm.x, p1.y + progress * norm.y);
    progress += dash;
    line.lineTo(p1.x + progress * norm.x, p1.y + progress * norm.y);
    progress += gap;

    // console.log("X= "+(p1.x+progress*norm.x)+" ,Y= "+ p1.y+progress*norm.y)
  }

  const line2 = new PIXI.Graphics();
  containers.axisContainer.addChild(line2);
  // line.position.set(150)
  const p12 = {
    x: appWidth * 0.027,
    y: appHeight * 0,
  };
  const p22 = {
    x: appWidth * 0.027,
    y: appHeight * 0.952,
  };
  line2.lineStyle(0.01, 0x000000);
  line2.moveTo(p12.x, p12.y).lineTo(p22.x, p22.y);
  const dash2 = 5;
  const gap2 = 5;
  const len2 = distance(p12, p22);
  const norm2 = {
    x: (p22.x - p12.x) / len2,
    y: (p22.y - p12.y) / len2,
  };
  line2.lineStyle(0.2, 0xffffff);
  line2
    .moveTo(p12.x, p12.y)
    .lineTo(p12.x + dash2 * norm2.x, p12.y + dash2 * norm2.y);
  var progress2 = dash2 + gap2;
  while (progress2 < len2) {
    line2.moveTo(p12.x + progress2 * norm2.x, p12.y + progress2 * norm2.y);
    progress2 += dash2;
    line2.lineTo(p12.x + progress2 * norm2.x, p12.y + progress2 * norm2.y);
    progress2 += gap2;

    //  console.log("X= "+(p12.x+progress2*norm2.x)+" ,Y= "+ p12.y+progress2*norm2.y)
  }
}

function setCenterText(s) {
  gameAssets.centerBigText.text = s;
  updateMultiplierBgBox();
}

export function ensureClassicRocketLayerOrder() {
  if (getActiveThemeSlug() === "theme-two") return;
  if (!containers.rootContainer || !containers.rocketContainer) return;

  if (containers.rocketContainer.parent === containers.rootContainer) {
    const loadingIndex = containers.rootContainer.getChildIndex(
      containers.loadingContainer,
    );
    const targetIndex =
      loadingIndex >= 0
        ? loadingIndex - 1
        : containers.rootContainer.children.length - 1;
    containers.rootContainer.setChildIndex(
      containers.rocketContainer,
      targetIndex,
    );
    if (
      containers.dummyPlanesContainer &&
      containers.dummyPlanesContainer.parent === containers.rootContainer
    ) {
      containers.rootContainer.setChildIndex(
        containers.dummyPlanesContainer,
        targetIndex - 1,
      );
    }
  } else if (
    containers.graphViewportContainer &&
    containers.graphViewportContainer.parent === containers.rootContainer
  ) {
    const loadingIndex = containers.rootContainer.getChildIndex(
      containers.loadingContainer,
    );
    const targetIndex =
      loadingIndex >= 0
        ? loadingIndex - 1
        : containers.rootContainer.children.length - 1;
    containers.rootContainer.setChildIndex(
      containers.graphViewportContainer,
      targetIndex,
    );
  }
}

export function updateMultiplierBgBox() {
  if (!gameAssets || !gameAssets.centerBigText || !gameAssets.multiplierBgBox)
    return;

  const isThemeTwo = getActiveThemeSlug() === "theme-two";
  if (!isThemeTwo) {
    const isPortrait = window.innerWidth < window.innerHeight;
    const width = window.innerWidth;
    const cardScale = width <= 360 ? 0.5 : width <= 540 ? 0.55 : width <= 768 ? 0.65 : width <= 1024 ? 0.75 : 1;
    const isCrashed = gameAssets.multiplierCrashed;
    const boxWidth = smokeAceMultiplier.width * cardScale;
    const boxHeight = smokeAceMultiplier.height * cardScale;
    const is768View = window.innerWidth <= 768;
    const targetX = (isPortrait || is768View)
      ? appWidth * 0.5
      : appWidth - smokeAceMultiplier.right - boxWidth / 2;
    const targetY = (isPortrait || is768View)
      ? (window.innerWidth > 540 && window.innerWidth <= 768 ? 65 : 65)
      : smokeAceMultiplier.landscapeTop + boxHeight / 2;
    const fontSize = smokeAceMultiplier.fontSize * cardScale;
    const isStarted = isGameStarted();
    const textColor = isCrashed
      ? smokeAceMultiplier.crashedTextColor
      : isStarted
        ? smokeAceMultiplier.flyingTextColor
        : "#FFFFFF";

    gameAssets.centerBigText.style.fill = [textColor];
    gameAssets.centerBigText.style.fontFamily =
      gameAssets.fonts.primaryExtraBold.fontFamily;
    gameAssets.centerBigText.style.fontSize = fontSize;
    gameAssets.centerBigText.style.fontWeight = "800";
    gameAssets.centerBigText.style.lineHeight = fontSize;
    gameAssets.centerBigText.style.align = "center";
    gameAssets.centerBigText.style.letterSpacing = 0;
    gameAssets.centerBigText.style.strokeThickness = 0;
    gameAssets.centerBigText.scale.set(1);
    gameAssets.centerBigText.resolution = 4;
    gameAssets.centerBigText.dirty = true;

    if (
      !gameAssets.centerBigText.visible ||
      !String(gameAssets.centerBigText.text || "").trim()
    ) {
      gameAssets.multiplierBgBox.visible = false;
      gameAssets.centerSmallText.visible = false;
      return;
    }

    const maxTextWidth = Math.max(8, boxWidth - 24 * cardScale);
    const measuredTextWidth = gameAssets.centerBigText.width || 0;
    if (measuredTextWidth > maxTextWidth) {
      gameAssets.centerBigText.scale.set(maxTextWidth / measuredTextWidth);
    }

    gameAssets.multiplierBgBox.visible = true;
    gameAssets.multiplierBgBox.clear();

    gameAssets.centerSmallText.visible = false;
    gameAssets.centerBigText.anchor.set(0.5);
    gameAssets.centerBigText.position.set(targetX, targetY);
    gameAssets.multiplierBgBox.lineStyle(
      smokeAceMultiplier.borderWidth,
      smokeAceMultiplier.borderColor,
      1,
    );
    gameAssets.multiplierBgBox.beginFill(smokeAceMultiplier.backgroundColor);
    gameAssets.multiplierBgBox.drawRoundedRect(
      -boxWidth / 2,
      -boxHeight / 2,
      boxWidth,
      boxHeight,
      smokeAceMultiplier.borderRadius * cardScale,
    );
    gameAssets.multiplierBgBox.endFill();
    gameAssets.multiplierBgBox.position.set(targetX, targetY);
    return;
  }

  if (!gameAssets.centerBigText.visible) {
    gameAssets.multiplierBgBox.visible = false;
    return;
  }

  gameAssets.multiplierBgBox.visible = true;
  const isPortrait = window.innerWidth < window.innerHeight;
  // Baseline appWidth for 1440px screen with 304px sidebar is 1136px
  const themeScale = isPortrait ? (appWidth / 540) : (appWidth / 1136);

  const multiplierFontSize = isPortrait ? Math.round(26 * themeScale) : Math.round(52 * themeScale);
  const multiplierPaddingX = isPortrait ? Math.round(76 * themeScale) : Math.round(84 * themeScale);
  const multiplierPaddingY = isPortrait ? Math.round(24 * themeScale) : Math.round(40 * themeScale);
  const multiplierBorderRadius = isPortrait ? Math.round(12 * themeScale) : Math.round(14 * themeScale);

  gameAssets.centerBigText.style.fontFamily = gameAssets.fonts.bold.fontFamily;
  gameAssets.centerBigText.style.fontSize = multiplierFontSize;
  gameAssets.centerBigText.style.fontWeight = "800";
  // Match lineHeight to fontSize so text metrics don't push glyphs to the top
  gameAssets.centerBigText.style.lineHeight = multiplierFontSize;
  gameAssets.centerBigText.style.align = "center";
  gameAssets.centerBigText.style.letterSpacing = 0;
  gameAssets.centerBigText.style.strokeThickness = 0;
  gameAssets.centerBigText.scale.set(1);
  gameAssets.centerBigText.resolution = 4;
  gameAssets.centerBigText.anchor.set(0.5);
  gameAssets.centerBigText.dirty = true;

  const is768View = window.innerWidth <= 768;
  const targetX = (isPortrait || is768View) ? appWidth * 0.5 : appWidth * 0.88;
  const targetY = (isPortrait || is768View)
    ? (window.innerWidth > 540 && window.innerWidth <= 768 ? 65 : 55)
    : Math.max(90, 100 * themeScale);

  // Box sized from fontSize (not asymmetric text bounds) so text can sit dead-center
  const textWidth = Math.round(gameAssets.centerBigText.width);
  const maxBoxWidth = Math.round(appWidth * (isPortrait ? 0.7 : 0.36));
  let boxWidth = Math.round(textWidth + multiplierPaddingX);
  const boxHeight = Math.round(multiplierFontSize + multiplierPaddingY);

  if (boxWidth > maxBoxWidth && textWidth > 0) {
    const fittedTextWidth = Math.max(8, maxBoxWidth - multiplierPaddingX);
    gameAssets.centerBigText.scale.set(fittedTextWidth / textWidth);
    boxWidth = maxBoxWidth;
  }

  gameAssets.centerBigText.position.set(targetX, targetY);

  gameAssets.multiplierBgBox.clear();
  gameAssets.multiplierBgBox.lineStyle(
    isPortrait ? Math.max(1.5, Math.round(2 * themeScale)) : Math.max(1.5, Math.round(2 * themeScale)),
    0xe76eff,
    1.0,
  );
  gameAssets.multiplierBgBox.beginFill(0x3c1e64);
  gameAssets.multiplierBgBox.drawRoundedRect(
    Math.round(-boxWidth / 2),
    Math.round(-boxHeight / 2),
    boxWidth,
    boxHeight,
    multiplierBorderRadius,
  );
  gameAssets.multiplierBgBox.endFill();

  gameAssets.multiplierBgBox.position.set(
    Math.round(targetX),
    Math.round(targetY),
  );
}

export function updateCrashLoadingTheme() {
  if (
    !gameAssets ||
    !gameAssets.loadingText ||
    !gameAssets.loadingBar1 ||
    !gameAssets.loadingBar2
  )
    return;

  const isThemeTwo = getActiveThemeSlug() === "theme-two";

  // Initialize loadingBgBox if it doesn't exist
  if (!gameAssets.loadingBgBox) {
    gameAssets.loadingBgBox = new PIXI.Graphics();
    containers.loadingContainer.addChildAt(gameAssets.loadingBgBox, 0);
  }

  if (!isThemeTwo) {
    const isPortrait = window.innerWidth < window.innerHeight;
    const width = window.innerWidth;
    const cardScale = width <= 360 ? 0.5 : width <= 540 ? 0.55 : width <= 768 ? 0.65 : width <= 1024 ? 0.75 : 1;
    const cardWidth = smokeAceStarting.width * cardScale;
    const cardHeight = smokeAceStarting.height * cardScale;

    const multiplierBoxHeight = smokeAceMultiplier.height * cardScale;
    const gap = 12 * cardScale;

    const is768View = window.innerWidth <= 768;
    const centerX = (isPortrait || is768View)
      ? appWidth * 0.5
      : appWidth - smokeAceStarting.right - cardWidth / 2;
    const centerY = (isPortrait || is768View)
      ? ((window.innerWidth > 540 && window.innerWidth <= 768 ? 65 : 65) + multiplierBoxHeight / 2 + gap + cardHeight / 2)
      : (smokeAceStarting.top + multiplierBoxHeight + gap + cardHeight / 2);
    const currentProgress =
      gameAssets.loadingBar1.width > 0
        ? Math.min(
            1,
            Math.max(
              0,
              gameAssets.loadingBar2.width / gameAssets.loadingBar1.width,
            ),
          )
        : 0;
    const textures = getSmokeAceLoadingTextures();

    gameAssets.loadingBgBox.visible = true;
    gameAssets.loadingBgBox.clear();
    gameAssets.loadingBgBox.lineStyle(
      smokeAceStarting.borderWidth,
      smokeAceStarting.borderColor,
      1,
    );
    gameAssets.loadingBgBox.beginFill(smokeAceStarting.backgroundColor);
    gameAssets.loadingBgBox.drawRoundedRect(
      -cardWidth / 2,
      -cardHeight / 2,
      cardWidth,
      cardHeight,
      smokeAceStarting.borderRadius * cardScale,
    );
    gameAssets.loadingBgBox.endFill();
    gameAssets.loadingBgBox.position.set(centerX, centerY);

    gameAssets.countdownText.visible = false;
    gameAssets.loadingText.visible = true;
    gameAssets.loadingText.text = "Starting in";
    gameAssets.loadingText.style.fill = [smokeAceStarting.textColor];
    gameAssets.loadingText.style.fontFamily = "Roboto";
    gameAssets.loadingText.style.fontSize =
      smokeAceStarting.fontSize * cardScale;
    gameAssets.loadingText.style.fontWeight = "800";
    gameAssets.loadingText.style.lineHeight =
      smokeAceStarting.lineHeight * cardScale;
    gameAssets.loadingText.style.align = "center";
    gameAssets.loadingText.style.strokeThickness = 0;
    gameAssets.loadingText.style.dropShadow = true;
    gameAssets.loadingText.style.dropShadowAlpha = 0.25;
    gameAssets.loadingText.style.dropShadowAngle = Math.PI / 2;
    gameAssets.loadingText.style.dropShadowBlur = 4 * cardScale;
    gameAssets.loadingText.style.dropShadowColor = "#000000";
    gameAssets.loadingText.style.dropShadowDistance = 4 * cardScale;
    gameAssets.loadingText.scale.set(1);
    gameAssets.loadingText.resolution = 4;
    gameAssets.loadingText.dirty = true;
    gameAssets.loadingText.position.set(
      centerX,
      centerY - 8 * cardScale,
    );

    if (textures) {
      gameAssets.loadingBar1.texture = textures.track;
      gameAssets.loadingBar2.texture = textures.fill;
    }
    gameAssets.loadingBar1.anchor.set(0.5);
    gameAssets.loadingBar1.scale.set(cardScale);
    gameAssets.loadingBar1.position.set(
      centerX,
      centerY + 16 * cardScale,
    );

    gameAssets.loadingBar2.anchor.set(0, 0.5);
    gameAssets.loadingBar2.scale.set(cardScale);
    gameAssets.loadingBar2.position.set(
      centerX - (smokeAceStarting.barWidth * cardScale) / 2,
      centerY + 16 * cardScale,
    );
    gameAssets.loadingBar2.width =
      gameAssets.loadingBar1.width * currentProgress;
    return;
  }

  const isPortrait = window.innerWidth < window.innerHeight;
  gameAssets.loadingBgBox.visible = true;
  gameAssets.countdownText.visible = false;

  const currentProgress =
    gameAssets.loadingBar1.width > 0
      ? Math.min(1, gameAssets.loadingBar2.width / gameAssets.loadingBar1.width)
      : 1;

  // Baseline appWidth for 540px portrait screen is 540px
  const themeScale = isPortrait ? (appWidth / 540) : (appWidth / 1136);

  const multiplierPaddingX = isPortrait ? Math.round(76 * themeScale) : Math.round(84 * themeScale);
  const multiplierPaddingY = isPortrait ? Math.round(24 * themeScale) : Math.round(40 * themeScale);

  const textWidth = Math.round(gameAssets.centerBigText.width);
  const multiplierBoxWidth = Math.round(textWidth + multiplierPaddingX);

  const boxW = multiplierBoxWidth;
  const boxH = isPortrait ? Math.round(58 * themeScale) : Math.round(74 * themeScale);
  const boxRadius = isPortrait ? Math.round(12 * themeScale) : Math.round(12 * themeScale);

  const mobileLoadingFontSize = isPortrait ? Math.round(14 * themeScale) : Math.round(17 * themeScale);
  gameAssets.loadingText.text = "Starting in 5";
  gameAssets.loadingText.style.fill = ["#F1E7FF"];
  gameAssets.loadingText.style.fontFamily = gameAssets.fonts.bold.fontFamily;
  gameAssets.loadingText.style.fontSize = mobileLoadingFontSize;
  gameAssets.loadingText.style.fontWeight = "800";
  gameAssets.loadingText.style.strokeThickness = 0;
  gameAssets.loadingText.style.dropShadow = true;
  gameAssets.loadingText.style.dropShadowColor = "#12081F";
  gameAssets.loadingText.style.dropShadowBlur = 6;
  gameAssets.loadingText.style.dropShadowDistance = 2;
  gameAssets.loadingText.style.dropShadowAlpha = 0.65;
  gameAssets.loadingText.scale.set(1);
  gameAssets.loadingText.resolution = 4;
  gameAssets.loadingText.dirty = true;

  const barW = isPortrait ? Math.round(102 * themeScale) : Math.round(132 * themeScale);
  const barH = isPortrait ? Math.round(12 * themeScale) : Math.round(12 * themeScale);
  const radius = barH / 2;

  // The legacy loader applies its own scale before theme styling runs. Reset
  // both sprites so the generated track/fill share the card's exact width.
  gameAssets.loadingBar1.scale.set(1);
  gameAssets.loadingBar2.scale.set(1);

  const trackG = new PIXI.Graphics();
  trackG.lineStyle(isPortrait ? Math.max(1, Math.round(1.5 * themeScale)) : Math.max(1, Math.round(1.5 * themeScale)), 0x5cff4a, 1.0);
  trackG.beginFill(0x251845);
  trackG.drawRoundedRect(0, 0, barW, barH, radius);
  trackG.endFill();
  gameAssets.loadingBar1.texture = frontApp.renderer.generateTexture(trackG);

  const fillerG = new PIXI.Graphics();
  fillerG.beginFill(0x33cc33);
  fillerG.drawRoundedRect(0, 0, barW, barH, radius);
  fillerG.endFill();
  gameAssets.loadingBar2.texture = frontApp.renderer.generateTexture(fillerG);

  gameAssets.loadingBar1.scale.set(1);
  gameAssets.loadingBar2.scale.set(1);
  gameAssets.loadingBar1.width = barW;
  gameAssets.loadingBar1.height = barH;
  gameAssets.loadingBar2.height = barH;
  gameAssets.loadingMaxWidth = barW;

  gameAssets.loadingBgBox.clear();
  gameAssets.loadingBgBox.lineStyle(
    isPortrait ? Math.max(1.5, Math.round(2 * themeScale)) : Math.max(1.5, Math.round(2 * themeScale)),
    0xe76eff,
    1.0,
  );
  gameAssets.loadingBgBox.beginFill(0x3c1e64);
  gameAssets.loadingBgBox.drawRoundedRect(
    Math.round(-boxW / 2),
    Math.round(-boxH / 2),
    boxW,
    boxH,
    boxRadius,
  );
  gameAssets.loadingBgBox.endFill();

  const is768View = window.innerWidth <= 768;
  const multiplierX = (isPortrait || is768View) ? appWidth * 0.5 : appWidth * 0.88;
  const multiplierY = (isPortrait || is768View)
    ? (window.innerWidth > 540 && window.innerWidth <= 768 ? 65 : 55)
    : Math.max(90, 100 * themeScale);

  const centerX = Math.round(multiplierX);
  const multiplierTextH = Math.round(gameAssets.centerBigText.height || (isPortrait ? 24 : 60 * themeScale));
  const multiplierBoxHeight = Math.round(multiplierTextH + multiplierPaddingY);
  const multiplierBoxBottom = multiplierY + multiplierBoxHeight / 2;
  const desiredGap = isPortrait ? Math.round(8 * themeScale) : Math.round(8 * themeScale);
  const centerY = Math.round(multiplierBoxBottom + desiredGap + boxH / 2);

  gameAssets.loadingBgBox.position.set(centerX, centerY);

  const textOffsetY = Math.round(boxH * 0.16);
  const barOffsetY = Math.round(boxH * 0.22);
  gameAssets.loadingText.position.set(
    centerX,
    Math.round(centerY - textOffsetY),
  );
  gameAssets.loadingBar1.position.set(
    centerX,
    Math.round(centerY + barOffsetY),
  );
  gameAssets.loadingBar1.anchor.set(0.5);

  gameAssets.loadingBar2.anchor.set(0, 0.5);
  gameAssets.loadingBar2.position.set(
    Math.round(centerX - barW / 2),
    Math.round(centerY + barOffsetY),
  );

  if (!gameAssets.loadingBarMask) {
    gameAssets.loadingBarMask = new PIXI.Graphics();
    containers.loadingContainer.addChild(gameAssets.loadingBarMask);
  }
  gameAssets.loadingBarMask.clear();
  gameAssets.loadingBarMask.beginFill(0xffffff);
  gameAssets.loadingBarMask.drawRoundedRect(0, 0, barW, barH, radius);
  gameAssets.loadingBarMask.endFill();
  gameAssets.loadingBarMask.position.set(
    Math.round(centerX - barW / 2),
    Math.round(centerY + barOffsetY - barH / 2),
  );
  gameAssets.loadingBar2.mask = gameAssets.loadingBarMask;
  gameAssets.loadingBar2.width = barW * currentProgress;
}

export function updateLoadingBarProgress(fillRatio) {
  if (!gameAssets || !gameAssets.loadingBar1 || !gameAssets.loadingBar2)
    return;

  const isThemeTwo = getActiveThemeSlug() === "theme-two";
  const ratio = Math.min(1, Math.max(0, fillRatio));

  if (!isThemeTwo) {
    const isPortrait = window.innerWidth < window.innerHeight;
    const width = window.innerWidth;
    const cardScale =
      width <= 360
        ? 0.5
        : width <= 540
          ? 0.55
          : width <= 768
            ? 0.65
            : width <= 1024
              ? 0.75
              : 1;
    const barW = smokeAceStarting.barWidth * cardScale;
    const startX = gameAssets.loadingBar1.position.x - barW / 2;

    gameAssets.loadingBar2.anchor.set(0, 0.5);
    gameAssets.loadingBar2.position.set(
      startX,
      gameAssets.loadingBar1.position.y,
    );
    gameAssets.loadingBar2.width = barW * ratio;
  } else {
    const isPortrait = window.innerWidth < window.innerHeight;
    const themeScale = isPortrait ? appWidth / 540 : appWidth / 1136;
    const barW = isPortrait
      ? Math.round(102 * themeScale)
      : Math.round(132 * themeScale);
    const startX = gameAssets.loadingBar1.position.x - barW / 2;

    gameAssets.loadingBar2.anchor.set(0, 0.5);
    gameAssets.loadingBar2.position.set(
      startX,
      gameAssets.loadingBar1.position.y,
    );
    gameAssets.loadingBar2.width = barW * ratio;
  }
}

function createDummyRockets() {
  gameAssets.nearestPlane = PIXI.Sprite.from("nearestPlane");
  gameAssets.nearestPlane.scale.set(2.25 * appAspectRatio);

  // let scale = getScale(
  //   gameAssets.rocket.width, gameAssets.rocket.height,
  //   window.innerWidth, window.innerHeight,
  //   scalingPercentage.desktop.mainPlane / 100  // this much of area will be taken by source
  // )
  // gameAssets.nearestPlane.scale.set(scale)
  gameAssets.nearestPlane.anchor.set(0.5);

  gameAssets.farthestPlane = PIXI.Sprite.from("farthestPlane");
  gameAssets.farthestPlane.scale.set(2.25 * appAspectRatio);
  gameAssets.farthestPlane.anchor.set(0.5);

  containers.dummyPlanesContainer.addChild(
    gameAssets.nearestPlane,
    gameAssets.farthestPlane,
  );

  gameAssets.nearestPlane.position.set(
    0 - gameAssets.nearestPlane.width,
    0 - gameAssets.nearestPlane.height,
  );

  gameAssets.farthestPlane.position.set(
    0 - gameAssets.farthestPlane.width,
    0 - gameAssets.farthestPlane.height,
  );

  if (window.matchMedia("(orientation: portrait)").matches) {
    // Scale down the background planes progressively on smaller mobile
    // viewports, matching the main plane's mobile scaling for Theme-One (classic)
    const nearestScaleMultiplier =
      window.innerWidth <= 360
        ? 0.4
        : window.innerWidth <= 540
          ? 0.5
          : window.innerWidth <= 768
            ? 0.6
            : 0.75;
    const farthestScaleMultiplier =
      window.innerWidth <= 360
        ? 0.5
        : window.innerWidth <= 540
          ? 0.6
          : window.innerWidth <= 768
            ? 0.7
            : 0.85;
    gameAssets.nearestPlane.scale.set(nearestScaleMultiplier * appAspectRatio);
    gameAssets.farthestPlane.scale.set(farthestScaleMultiplier * appAspectRatio);
  }
}

function createRocket() {
  // ------ Assets got replaced! ------
  // gameAssets.rocketTextures[0] = PIXI.Assets.get("allAssets").textures.char1
  // gameAssets.rocketTextures[1] = PIXI.Assets.get("allAssets").textures.char2
  // gameAssets.rocketTextures[2] = PIXI.Assets.get("allAssets").textures.char3

  gameAssets.rocket = spriteSettings(
    gameAssets.rocket,
    PIXI.Assets.get("smokeAceFly"),
    containers.rocketContainer,
  );

  if (window.matchMedia("(orientation: portrait)").matches) {
    // Mobile
    gameAssets.rocket.scale.set(0.75 * appAspectRatioX);
  } else {
    // Desktop
    gameAssets.rocket.scale.set(1.1 * appAspectRatioX);
  }

  const explosion = PIXI.Assets.get("explosion");
  gameAssets.explosionAnim = new PIXI.AnimatedSprite(
    explosion.animations.explode,
  );
  gameAssets.explosionAnim.anchor.set(0.5);
  gameAssets.explosionAnim.scale.set(0.9 * appAspectRatio);
  gameAssets.explosionAnim.animationSpeed = 0.1;
  gameAssets.explosionAnim.loop = false;
  gameAssets.explosionAnim.visible = false;

  containers.rocketContainer.addChild(gameAssets.explosionAnim);

  if (window.matchMedia("(orientation: portrait)").matches) {
    gameAssets.rocket.scale.set(0.55 * appAspectRatio);
    gameAssets.explosionAnim.scale.set(0.25 * appAspectRatio);
  }
}

function createGraph() {
  // gameAssets.bottomGradient = spriteSettings(gameAssets.bottomGradient, PIXI.Assets.get("allAssets").textures.graphGrad, containers.bgContainer)
  // gameAssets.bottomGradient.width = appWidth
  // gameAssets.bottomGradient.height = appHeight
  // gameAssets.bottomGradient.position.set(appWidth * 0.5, appHeight * 0.5)

  //  gameAssets.bottomGradient.mask = gameAssets.bottomLineGraph

  //  containers.graphContainer.addChild(gameAssets.bottomGradient)
  containers.graphContainer.addChild(gameAssets.bottomLineGraph);
  containers.graphContainer.addChild(gameAssets.topLineGraph);
  const isThemeTwo = getActiveThemeSlug() === "theme-two";
  const isPortrait = window.innerWidth < window.innerHeight;
  const graphYPos = isThemeTwo
    ? isPortrait
      ? -appHeight * 0.02
      : appHeight * 0.02
    : 0;
  const graphXPos = isThemeTwo ? appWidth * 0.01 : 0;
  containers.graphContainer.position.set(graphXPos, graphYPos);
}

function createCenterText() {
  gameAssets.multiplierBgBox = new PIXI.Graphics();

  gameAssets.centerBigText = new PIXI.Text(
    "",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.ultraRegular.fontFamily,
      fill: ["#48A29C"],
      fontSize: 80,
    }),
  );

  gameAssets.centerBigText.anchor.set(0.5);
  if (window.matchMedia("(orientation: portrait)").matches) {
    // Mobile
    gameAssets.centerBigText.scale.set(1 * appAspectRatioX);
  } else {
    // Desktop
    gameAssets.centerBigText.scale.set(1.4 * appAspectRatioX);
  }
  // gameAssets.centerBigText.position.set(appWidth * 0.85, gameAssets.centerBigText.height)

  gameAssets.centerSmallText = new PIXI.Text(
    "CRASHED",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.ultraRegular.fontFamily,
      fill: ["#A92A4E"],
      fontSize: 90,
    }),
  );

  containers.centerTextContainer.addChild(
    gameAssets.multiplierBgBox,
    gameAssets.centerSmallText,
    gameAssets.centerBigText,
  );
  gameAssets.centerSmallText.anchor.set(0.5);
  gameAssets.centerSmallText.scale.set(1 * appAspectRatioX);

  gameAssets.centerSmallText.position.set(
    gameAssets.centerBigText.x - gameAssets.centerBigText.width,
    gameAssets.centerBigText.y,
  );

  gameAssets.crashCenterText = new PIXI.Text(
    "TAKEN OFF!",
    new PIXI.TextStyle({
      fontFamily: gameAssets.fonts.semiBold.fontFamily,
      fill: ["#FFFFFF"],
      fontSize: 100,
      align: "center",
    }),
  );
  gameAssets.crashCenterText.anchor.set(0.5);
  gameAssets.crashCenterText.scale.set(appAspectRatioX * 0.9);
  gameAssets.crashCenterText.position.set(appWidth * 0.5, appHeight * 0.5);
  containers.centerTextContainer.addChild(gameAssets.crashCenterText);

  if (window.matchMedia("(orientation: portrait)").matches) {
    // gameAssets.centerBigText.position.set(appWidth * 0.5, gameAssets.centerBigText.height)
    // gameAssets.centerSmallText.position.set(
    //   gameAssets.centerBigText.x,
    //   gameAssets.centerBigText.y
    //   //+ gameAssets.centerBigText.height * 1.25
    // )
    gameAssets.centerBigText.style.fontSize = 120;
  }

  gameAssets.crashCenterText.visible = false;
}

export {
  toggleAnimation,
  applyAnimationVisibility,
  isAnimationEnabled,
  containers,
  gameAssets,
  createUI,
  uiCreated,
  appHeight,
  appWidth,
  setCenterText,
};
